import { render, staticRenderFns } from "./BillingDetailSection.vue?vue&type=template&id=c1653d1a&"
import script from "./BillingDetailSection.vue?vue&type=script&lang=ts&"
export * from "./BillingDetailSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports